import React, { useContext } from "react";
import menuIcon from "../../Assets/Icons/panel-right-close.svg";
import profile from "../../Assets/Icons/profile.svg";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { UserContext } from "../../App";

const Navbar = ({ title, collapsed, setCollapsed }) => {
  const { userData } = useContext(UserContext);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/profile");
  };

  return (
    <div className="navbar">
      <div className="header-wrapper">
        <div className="collapser">
          <img
            className="panel-icon"
            src={menuIcon}
            alt="Toggle Sidebar"
            onClick={() => setCollapsed(!collapsed)}
          />
        </div>
        <div className="wrapper">
          <div className="title">{title}</div>
          <div
            className="user-div"
            onClick={handleClick}
            style={{ cursor: "pointer" }}
          >
            <div className="profile">
              <img style={{ width: "30px" }} src={profile} alt="profile" />
            </div>
            <div className="name">{userData?.name}</div>
          </div>
        </div>
      </div>
      <div className="divider"></div>
    </div>
  );
};

export default Navbar;
